import React, { useState, Component, useEffect, useRef } from 'react';
import '../../src/Hero2.css';
import { Loader } from 'semantic-ui-react';
import { Mensaje } from './mensajes';
import 'animate.css';
import Fade from 'react-reveal/Fade';
import Reveal from 'react-reveal/Reveal';
import Slide from 'react-reveal/Slide';
import Roll from 'react-reveal/Roll';
import Jello from 'react-reveal/Jello';
import makeCarousel from 'react-reveal/makeCarousel';
import styled, { css } from 'styled-components';
import Form from 'react-bootstrap/Form';
import axios from 'axios';
import { Dimmer } from 'semantic-ui-react';
import Feedback from 'react-bootstrap/Feedback';
import '../../public/icons/style.css';
import Contactos from './contactanos';
import Ubicanos from './ubicanos';
import QuienesSomos from './quienes';
import Mision from './mision';






function Menu2() {



    const [mostrar, setMostrar] = useState();
    const [mostrar1, setMostrar1] = useState(false);
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [activate, setActivate] = useState(false);
    const [values, setValues] = useState({
        txtNombre: '',
        txtEmail: ''
    });

    const repetir = () => {

        let slider = document.querySelector(".slier-prin");
        slider.innerHTML += slider.innerHTML += slider.innerHTML += slider.innerHTML += slider.innerHTML
    }

    const abrirModal = () => {
        setMostrar(true);
    }

    const cerrarModal = () => {
        setMostrar(false);
    }

    const enviarCorreo = () => {

        setActivate(true);



        let endpoint = "http://3.141.30.169:5000/send-email";

        axios.post(endpoint, {

            email: 'tvalentin@gmail.com',
            name: values.txtEmail,
            passwd: '',
            message: values.txtNombre

        }).then(function (response) {

            if (response.status == 200) {

                setTitulo("enviado con exito!");
                setMsg('pronto recibirar respuestas');
                setMostrar1(true);

            } else if (response.status == 204) {
                setTitulo("notificación");
                setMsg("correo no encontrado");
                setMostrar1(true);


            }


        }).catch(function (error) {
            setTitulo("notificación");
            setMsg("Error interno de Conexión.");
            setMostrar1(true);

        }).then(function () {
            setActivate(false);
        });

    }

    const onChange = (event) => {

        setValues({ ...values, [event.target.name]: event.target.value });

    };


    const handleCloseMensa = () => {

        setMostrar1(false);

    }

    const [validated, setValidated] = useState(false);

    const handleSubmit = (event) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            enviarCorreo();
        }

        setValidated(true);
    };

    const contactos = () => {

        setMostrar('contactos')

    }

    const ubicanos = () => {

        setMostrar('ubicanos')

    }

    const ocultar = () => {
        setMostrar('ocultar')
    }

    const quienes = () => {
        setMostrar('quienes')
    }

    const mision = () => {
        setMostrar('mision')
    }


    useEffect(() => {

        repetir()

    }, []);

    console.log(values)

    return (



        <div className='contenedorTotal '  >


            {/* Somos */}
            <div className='col-md-12 mx-auto row'>

                <div className='col-md-4 mx-auto'>

                    <img className='card-img mx-auto img-fluid' src='imagenes/vector1.jpg' />


                </div>

                <div className='col-md-6 padre mb-4'>
                    <h3 className='col-md-10 my-auto mx-auto text-center hijo '>
                        Somos una empresa lider de soluciones y aplicaciones informaticas de gestion administrativa y tributaria en el sector publico, ofreciendo un servicio de calidad y una continua actualización tecnologica.
                    </h3>
                </div>

            </div>





            {/* items hover */}
            <div className='d-none d-xl-block row col-md-12' style={{ height: 'auto', padding: '70px' }}>
                <div className="row mx-auto container ">

                    <div className="col text-center box-icono">
                        <a onClick={contactos} href='#contactos' name='contactos'>

                            <i className='fa-solid fa-address-card icono'></i>
                            <br />
                            <label className='iclabel'>Contactos</label>
                        </a>
                    </div>

                    <div className="col text-center box-icono">
                        <a onClick={ubicanos} href='#ubicanos' name='ubicanos' >

                            <i className='fa-solid fa-earth-asia icono'></i>
                            <br />
                            <label className='iclabel'>Ubicanos</label>
                        </a>
                    </div>
                    <div className="col text-center box-icono">
                        <a onClick={quienes} href='#quienes' name='quienes'>
                            <i className='fa-solid fa-chalkboard-user icono'></i>

                            <br />
                            <label className='iclabel'>Quienes Somos</label>
                        </a>
                    </div>
                    <div className="col text-center box-icono">
                        <a onClick={mision} href='#mision' name='mision'>
                            <i className='fa-solid fa-network-wired icono'></i>
                            <br />

                            <label className='iclabel'>Mision</label>
                        </a>
                    </div>
                </div>

            </div>



            {/* cuadros hover */}
            <div className=' col-md-12 back-cuadros container-fluid' style={{ padding: '60px 0' }}>
                <div className='container-fluid col-md-12' style={{ padding: '0  0 30px 0' }}>
                    <h1 className='text-light' style={{ textAlign: 'center' }}> Conoce Todos Nuestros Productos y Servicios...</h1>

                </div>
                <div className='col-md-10 mx-auto d-none d-xl-block'>


                    <div className='container-fluid row rounded-lg mx-auto col-md-12' >

                        <div className='col-md-6 back' style={{ margin: 0, padding: 0 }}>

                            <div className='box'>
                                <img className='img-fluid' src='imagenes/blanco.jpeg' style={{ width: '100%' }} />
                                <div className='background-hover'></div>
                                <div className='contenido-hover'>
                                    <h1 className="h1-text">Productos</h1>
                                    <p className="p-text" >
                                        Sygre C.A. a desarrollado OPEN-SIAP, un sistema integrado para la gestión administrativa de las organizaciones del sector público, cuenta con una gran experiencia de implementación, madurez y crecimiento, proporcionando a nuestros clientes, soluciones adaptadas a su medida, cumpliendo con la normativa legal vigente que rigen para el sector de la administración pública.
                                    </p>
                                </div>
                            </div>

                        </div>

                        <div className='col-md-6  back' style={{ margin: 0, padding: 0 }}>
                            <div className='box'>
                                <img className='img-fluid' src='imagenes/blanco.jpeg' style={{ width: '100%' }} />
                                <div className='background-hover'></div>
                                <div className='contenido-hover'>
                                    <h1 className="h1-text">Experiencia</h1>
                                    <p className="p-text" >
                                        Contamos con más de 22 años de experiencia atendiendo al sector público, prestando nuestros servicios de ventas de equipos informáticos, configuración e instalación de redes de datos, cobranzas de impuestos, asesoría legal, administración tributaria.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-6 back' style={{ margin: 0, padding: 0 }}>
                            <div className='box'>
                                <img className='img-fluid' src='imagenes/blanco.jpeg' style={{ width: '100%' }} />
                                <div className='background-hover'></div>
                                <div className='contenido-hover'>
                                    <h1 className="h1-text">Quienes Somos</h1>
                                    <p className="p-text" >Somos una empresa lider de soluciones y aplicaciones informaticas de gestion administrativa y tributaria en el sector publico, ofreciendo un servicio de calidad y una continua actualización tecnologica.</p>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-6 back' style={{ margin: 0, padding: 0 }}>
                            <div className='box'>
                                <img className='img-fluid' src='imagenes/blanco.jpeg' style={{ width: '100%' }} />
                                <div className='background-hover'></div>
                                <div className='contenido-hover'>
                                    <h1 className="h1-text">Clientes</h1>
                                    <p className="p-text" >
                                        Son varias las instituciones del sector público y privado que han confiado su gestión
                                        administrativa y contable, a los productos y servicios de SYGRE,C.A.
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div className='row d-block d-xl-none col-md-12 '>
                    <div className='col-md-12 mx-auto row'>

                        <div className='cuadro sombras py-5'>

                            <a className='col-md-12 mx-auto row' type="button" href='/quienessomos' >
                                <p className='my-auto col-md-12 fa-2x'><i class="fa-solid fa-industry"></i></p>
                                <p className='my-auto col-md-12 fw-bold '>Quienes Somos</p>
                            </a>


                        </div>

                        <div className='cuadro sombras py-5'>

                            <a className='col-md-12 mx-auto row' type="button" href='/productos' >
                                <p className='my-auto col-md-12 fa-2x'><i class="fa-brands fa-product-hunt"></i></p>
                                <p className='my-auto col-md-12 fw-bold '>Productos</p>
                            </a>


                        </div>
                        <div className='cuadro sombras py-5'>

                            <a className='col-md-12 mx-auto row' type="button" >
                                <p className='my-auto col-md-12 fa-2x'><i class="fa-solid fa-desktop"></i> </p>
                                <p className='my-auto col-md-12 fw-bold '>Experiencia</p>
                            </a>

                        </div>
                        <div className='cuadro sombras py-5'>

                            <a className='col-md-12 mx-auto row' type="button" >
                                <p className='my-auto col-md-12 fa-2x'><i class="fa-solid fa-users"></i> </p>
                                <p className='my-auto col-md-12 fw-bold '>Clientes</p>
                            </a>




                        </div>


                    </div>
                </div>


            </div>

         
            {/* carrusel de saberes */}

            <h1 className='text-center mt-5'>Lenguajes de Programación</h1>
            <div className="cont-princ-slider mb-5">
                <div className="slier-prin">
                    <div className="juegos_DWG">
                        <a target="_blank" href='https://www.amazon.com/s?k=amaon&adgrpid=81256009653&gclid=CjwKCAjwy_aUBhACEiwA2IHHQH2sZf7jiAczpSKcXD1Qas-kr0_K9HrNsWgUfy7O8cFgAOQabTX7iRoC8_EQAvD_BwE&hvadid=393559199195&hvdev=c&hvlocphy=1028562&hvnetw=g&hvqmt=b&hvrand=7867247862751320074&hvtargid=kwd-26342230&hydadcr=21587_10785041&tag=hydglogoo-20&ref=pd_sl_8w5d5axil3_b'><img className='img-fluid' src='imagenes/logoamazon.png' /></a>
                    </div>
                    <div className="juegos_DWG">
                        <a target="_blank" href='https://esflutter.dev/docs/resources/bootstrap-into-dart'><img className='img-fluid' src='imagenes/logodark.png' /></a>
                    </div>
                    <div className="juegos_DWG">
                        <a target="_blank" href='https://flutter.dev/?gclid=CjwKCAjwy_aUBhACEiwA2IHHQPmFfFvD3aJLYbYraWH00-dYdddTSXVCijh-MYcr3BI894tOMtta8xoCC30QAvD_BwE&gclsrc=aw.ds'><img className='img-fluid' src='imagenes/logoflutter.png' /></a>
                    </div>
                    <div className="juegos_DWG">
                        <a target="_blank" href='https://nodejs.org/es/about/'><img className='img-fluid' src='imagenes/logonode.png' /></a>
                    </div>
                    <div className="juegos_DWG">
                        <a target="_blank" href='https://www.postgresql.org/'><img className='img-fluid' src='imagenes/logopostgre.png' /></a>
                    </div>
                    <div className="juegos_DWG">
                        <a target="_blank" href='https://www.python.org/'><img className='img-fluid' src='imagenes/logopython.png' /></a>
                    </div>
                    <div className="juegos_DWG">
                        <a target="_blank" href='https://es.reactjs.org/'><img className='img-fluid' src='imagenes/logoreact.png' /></a>
                    </div>
                    <div className="juegos_DWG">
                        <a target="_blank" href='https://wordpress.org/plugins/plerdy-heatmap/?gclid=CjwKCAjwy_aUBhACEiwA2IHHQGR1BHYj7_TeOpLR4viwwL-FxCzrOiam4sQA-KOlRnYlKiB9VmWcohoC-b8QAvD_BwE'><img className='img-fluid' src='imagenes/logowordpress.png' /></a>
                    </div>

                </div>
            </div>



            {/* cards */}
          {/*   <div className='d-none d-xl-block col-md-12 row mx-auto'>
                <div className=' container row mx-auto'>

                    <div className='col-md-4 text-center'>
                        <div className='col-md-12 card-back rounded-circle shadow p-3 mb-5 bg-body mx-auto'>

                            <div className='card-box '>
                                <img className='card-img mx-auto img-fluid' src='imagenes/sistemas.png' />
                                <div className='card-background-hover'></div>

                            </div>

                        </div>
                        <h1>Sistemas/Apps</h1>
                        <a href='#' >Más información</a>
                    </div>

                    <div className='col-md-4 text-center'>
                        <div className='col-md-12 card-back rounded-circle shadow p-3 mb-5 bg-body mx-auto'>

                            <div className='card-box '>
                                <img className='card-img mx-auto img-fluid' src='imagenes/redes.png' />
                                <div className='card-background-hover'></div>

                            </div>
                        </div>
                        <h1>Comunicación/Redes</h1>
                        <a href='#' >Más información</a>
                    </div>

                    <div className='col-md-4 text-center'>
                        <div className='col-md-12 card-back rounded-circle shadow p-3 mb-5 bg-body mx-auto'>

                            <div className='card-box '>
                                <img className='card-img mx-auto img-fluid' src='imagenes/equipos.png' />
                                <div className='card-background-hover'></div>

                            </div>

                        </div>
                        <h1>Equipos</h1>
                        <a href='#' >Más información</a>
                    </div>
                </div>

            </div>
 */}


            <div className='d-block d-xl-none col-md-12 row mx-auto' style={{ height: '70vh', padding: '40px', marginTop: '6%' }}>

                <div className=' container row mx-auto'>

                    <div id="carouselExampleFade" class="carousel slide carousel-fade" data-bs-ride="carousel">
                        <div class="carousel-inner">
                            <div class="carousel-item active " data-bs-interval="4000">
                                <div className='text-center'>
                                    <div className='col-md-12 card-back rounded-circle shadow p-3 mb-5 bg-body mx-auto'>

                                        <div className='card-box '>
                                            <img className='card-img mx-auto img-fluid' src='imagenes/sistemas.png' />
                                            <div className='card-background-hover'></div>

                                        </div>

                                    </div>
                                    <h1>Sistemas<br />/Apps</h1>
                                    <a href='#' >Más información</a>
                                </div>
                            </div>
                            <div class="carousel-item" data-bs-interval="3000">
                                <div className='text-center'>
                                    <div className='col-md-12 card-back rounded-circle shadow p-3 mb-5 bg-body mx-auto'>

                                        <div className='card-box '>
                                            <img className='card-img mx-auto img-fluid' src='imagenes/redes.png' />
                                            <div className='card-background-hover'></div>

                                        </div>
                                    </div>
                                    <h1>Comunicación<br />/Redes</h1>
                                    <a href='#' >Más información</a>
                                </div>
                            </div>
                            <div class="carousel-item">
                                <div className='text-center' data-bs-interval="2000">
                                    <div className='col-md-12 card-back rounded-circle shadow p-3 mb-5 bg-body mx-auto'>

                                        <div className='card-box '>
                                            <img className='card-img mx-auto img-fluid' src='imagenes/equipos.png' />
                                            <div className='card-background-hover'></div>

                                        </div>

                                    </div>
                                    <h1>Equipos</h1>
                                    <a href='#' >Más información</a>
                                </div>
                            </div>
                        </div>
                        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="prev">
                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span class="visually-hidden">Previous</span>
                        </button>
                        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="next">
                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                            <span class="visually-hidden">Next</span>
                        </button>
                    </div>

                </div>
            </div>


            {/* contenido extra */}

            {mostrar === 'contactos' ?

                <div id='contactos'>
                    <Contactos />
                </div>
                : mostrar === 'ubicanos' ?
                    <div id='ubicanos'>
                        <Ubicanos />
                    </div>
                    : mostrar === 'quienes' ?
                        <div id='quienes'>
                            <QuienesSomos />
                        </div>
                        : mostrar === 'mision' ?
                            <div id='mision'>
                                <Mision />
                            </div>
                            :
                            ''}


            <Mensaje titulo={titulo} mensaje={msg}
                show={mostrar1}
                onHide={handleCloseMensa} />







        </div >




    )

} export default Menu2;



// WEBPACK FOOTER //
// ./src/components/Menu.js